var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"grid grid--middle"},[_c('div',{staticClass:"grid__cell r1-2"},[_c('ul',{staticClass:"links"},_vm._l((_vm.menu),function(item, key){return _c('li',[_c('router-link',{attrs:{"to":item.anchor}},[_vm._v(_vm._s(item.name))])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0650ed30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/features/Navfooter/index.vue
// module id = 6x5o
// module chunks = 1